import { useContext } from "react";
import { Context } from "../../utils/context";

const Pagination = () => {
  const {page, pageCount, setPage} = useContext(Context);
  return (
    <div className="pagination">
      <button
        className="paginate"
        key="prev"
        onClick={() => setPage((prev) => prev - 1)}
        disabled={page === 1}
      >
        {"<"}Previous
      </button>
      <span>{`${page} of ${pageCount}`}</span>
      <button
        className="paginate"
        key="next"
        onClick={() => setPage((prev) => prev + 1)}
        disabled={page === pageCount}
      >
        Next {">"}
      </button>
    </div>
  );
};

export default Pagination;
